import { Formik } from "formik";
import moment from "moment";
import {
  FocusEvent,
  useContext,
  useEffect,
  useMemo, useState
} from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import ShowStatus from "src/app/modules/component/ShowStatus";
import useIndexDBValue from "../../../../hook/useIndexDBValue";
import { AppContext } from "../../../appContext/AppContext";
import ButtonInPhieu from "../../../component/button-in-phieu";
import CellFormatter from "../../../component/cell-formatter";
import DanhSachPhieu from "../../../component/DanhSachPhieu";
import LabelRequired from "../../../component/LabelRequired";
import { TableCustomCell } from "../../../component/table/components/TableCustomCell";
import { TableCollapseCustom } from "../../../component/table/table-collapse/TableCollapseCustom";
import TextField from "../../../component/TextField";
import ModalThucHienChuyenKhoa from "../../../phan-he-chuyen-khoa/components/modal-thuc-hien/ModalThucHienChuyenKhoa";
import {
  createObsValue,
} from "../../../phan-he-chuyen-khoa/services/PhanHeChuyenKhoaService";
import { IDanhSachDanhMuc } from "../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { getPaymentDetail } from "../../../phan-he-vien-phi/services/PhanHeVienPhiServices";
import DynamicComponentXN from "../../../phan-he-xet-nghiem/components/DynamicComponentXN";
import {
  CODE,
  CODE_SUCCESS,
  KEY,
  KEY_DS_DANH_MUC_TIEP_DON,
  LIST_COLOR_TRANG_THAI_PHIEU,
  MENU_ACTION,
  ORDER_TYPE_ID,
  RESPONSE_MESSAGE,
  TERM_TYPE
} from "../../../utils/Constant";
import {
  formatDateToDDMMYYYY
} from "../../../utils/FormatUtils";
import { cancelService } from "../../../utils/ServicesUtils";
import WfButton from "../../../workflows/components/WfButton";
import WfContextMenu from "../../../workflows/components/WfContextMenu";
import {
  WfConstTracker,
  WfConstTrackerClinical
} from "../../../workflows/Constant";
import { getWorkflowTrackerFieldConfig } from "../../../workflows/utils";
import CheckIcon from "../../components/CheckIcon";
import { WORKFLOW_ORDER_GROUP_STATUS_CODE } from "../../constants/ChiDinhDVConst";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import "../../PhanHeKhamBenh.scss";
import {
  deleteDSChiDinhDV,
  getDSDVDaChiDinh,
  getServiceListByType,
  updateOrderGroupFields
} from "../../services/ChiDinhDVService";
import { getStatusDesc } from "../../services/KhamBenhService";
import { inPhieuChiDinhChung, inPhieuChiDinhCLS } from "../../services/PrintExportService";
import { SIGNATURE_MODULE, SIGNATURE_OBJECT_TYPE, SIGNATURE_TYPE } from "src/app/modules/component/button-in-phieu/constant";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";
import { SelectEditor, useSelectEditorManager } from "src/app/modules/component/select-editor";
import { seachUserMetadata } from "src/app/modules/auth/core/_requests";

export type KhamBenh = {
  thongTinKhamBenh?: any;
  setThongTinKhamBenh: ((data: any) => void) | undefined;
};

interface Iprops {
  danhSachPhieu?: boolean;
  generalInfo?: any;
  onUpdate?: () => void;
}

export const TabChuyenKhoa = ({ danhSachPhieu = true, generalInfo, onUpdate }: Iprops) => {
  const { benhNhanInfo, setBenhNhanInfo, setThongTinChiPhi, } = useContext(PhanHeTiepDonContext);
  const { value: categories } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });
  let { visit, patient, isConclusion, isExamined, orderId, deptFulfillDeptName, encounter } =
    benhNhanInfo?.thongTinKhamBenh ?? generalInfo ?? {};
  const [dsXetNghiemDetail, setDsXetNghiemDetail] = useState<any[]>([]);
  const [dsPhieu, setDsPhieu] = useState<any[]>([]);
  const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState<any>(0);
  const [rowSelected, setRowSelected] = useState<any>();
  const [contextMenu, setContextMenu] = useState<null | {
    x: number;
    y: number;
  }>(null);
  const [dynamicData, setDynamicData] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [shouldOpenResultModal, setShouldOpenResultModal] =
    useState<boolean>(false);
  const { setIsLoading } = useContext(AppContext);
  const [fieldLoading, setFieldLoading] = useState<any>({});
  const [isHasData, setIsHasData] = useState<boolean>(false);
  const [itemService, setItemService] = useState<any>(null);
  const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);
  const [currentStatusWf, setCurrentStatusWf] = useState<string>();
  const [generalData, setGeneralData] = useState<any>(null);
  const [statusDesc, setStatusDesc] = useState<any>([]);
  const [currentOrderId, setCurrentOrderId] = useState<string>(orderId);

  const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });

  const allowEdit = !isConclusion && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  const indicationTimeManager = useTimeEditorManager({
    name: "indicationTime",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationTime) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationTime: updatedData.indicationTime
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
            : phieu
        )
      );
    }
  });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "indicationPerson",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      indicationPerson: option?.fullName,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationPerson) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationPerson: updatedData.indicationPerson
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationPerson: updatedData.indicationPerson }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const requestDeptNameSelectManager = useSelectEditorManager({
    name: "requestDeptName",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      requestDeptCode: option?.code,
      requestDeptName: option?.name,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.requestDeptName) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        requestDeptName: updatedData.requestDeptName
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, requestDeptName: updatedData.requestDeptName }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false,
  });

  const handleUpdate = () => {
    if (onUpdate) {
      onUpdate();
    } else {
      setBenhNhanInfo({
        ...benhNhanInfo,
        shouldUpdate: !benhNhanInfo?.shouldUpdate,
      });
    }
  };

  const handleReset = () => {
    setDsPhieu([]);
    setSelectedPhieu(null);
    setDsXetNghiemDetail([]);
  };

  useEffect(() => {
    setGeneralData({
      patient,
      visit,
      encounter,
      orderId: rowSelected?.orderId,
      orderGroupId: selectedPhieu?.id,
      fulfillDeptName: deptFulfillDeptName || rowSelected?.fulfillDept,
      fulfillDeptCode: rowSelected?.fulfillDeptCode,
      isConclusion,
      isExamined,
      forDVKT: true,
    });
  }, [benhNhanInfo, generalInfo, rowSelected]);

  const actionChanged = (statusCode?: string) => {
      setCurrentStatusWf(statusCode);
      handleSelectPhieu(selectedPhieu);
      handleUpdate();
      setIsUpdateWorkflow(!isUpdateWorkflow);
      toast.success(RESPONSE_MESSAGE.SUCCESS);
  };

  const handleGetThongTinKhamBenh = async () => {
    let { data: dataChiPhi } = await getPaymentDetail(visit?.id);
    if (CODE.SUCCESS === dataChiPhi?.code) {
      setThongTinChiPhi({
        ...dataChiPhi?.data,
        ttDiscount:
          dataChiPhi?.data?.ttDiscountInv +
          dataChiPhi?.data?.ttDiscountPercent,
      });
    }
  };

  const handleContextMenu = (e: any, row: any, parentRow: any) => {
    e.preventDefault();
    try {
      // Là dvu
      if(row?.id){
        setRowSelected({
          ...row,
          fulfillDept: parentRow?.fulfillDept,
          fulfillDeptCode: parentRow?.fulfillDeptCode,
        });
        setItemService(row)
        setContextMenu({ x: e.clientX, y: e.clientY });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFieldLoading({});
    }
  };

  const handleCancelService = async (value: any) => {
    try {
      const obj = {
        termType: TERM_TYPE.PTTT,
        termOrderId: rowSelected?.termOrderId,
        cancelReason: value?.canceledReason,
        menuAction: MENU_ACTION.KHAM_BENH,
        statusId: dynamicData?.statusReq?.status
      }
      
      let { data } = await cancelService(obj);
      if(CODE.SUCCESS === data?.code && data?.data) {
        toast.success("Bỏ dịch vụ thành công!");
        handleSelectPhieu(selectedPhieu);
        handleGetThongTinKhamBenh();
        setSelectedIndex(0);
        handleClearContext();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleSelectPhieu = async (dataPhieu: any) => {
    try {
      if (!dataPhieu) {
        handleReset();
        return;
      };
      setSelectedIndex(dataPhieu?.index);

      // ⚡ OPTIMIZATION: Chỉ load danh sách dịch vụ, indication info sẽ load khi cần (lazy load)
      const dvResponse = await getDSDVDaChiDinh({
        orderGroupId: dataPhieu?.id,
      });

      // Set selectedPhieu ngay, indication info sẽ được load trong IndicationTimeEditor khi cần
      setSelectedPhieu(dataPhieu);

      // Xử lý danh sách dịch vụ
      if (dvResponse?.data?.code === CODE.SUCCESS) {
        const newData = dvResponse.data.data?.map((item: any) => {
          return {
            ...item,
            details: `${item?.fulfillDept}, Ngày ${
              item?.indicationDate
                ? formatDateToDDMMYYYY(item?.indicationDate)
                : ""
            }`,
            terms: item?.terms?.map((term: any) => {
              if (term?.subs) {
                return {
                  ...term,
                  status: item?.color,
                  name: (
                    <CheckIcon
                      data={term}
                      color={term?.statusColor}
                      className="ml-2"
                    />
                  ),
                  subs: term?.subs?.map((sub: any) => {
                    return {
                      ...sub,
                      isCancel: term?.isCancel,
                      name: <CheckIcon
                        data={{ ...sub, isCancel: term?.isCancel }}
                        color={term?.statusColor}
                      />,
                    };
                  }),
                };
              } else {
                return {
                  ...term,
                  status: item?.color,
                  name: <CheckIcon data={term} color={term?.statusColor} />,
                };
              }
            }),
          };
        });
        console.log(" TabChuyenKhoa - Loaded services:", newData?.length, "items");
        setDsXetNghiemDetail(newData || []);
      } else {
        console.log("❌ TabChuyenKhoa - No services found, code:", dvResponse?.data?.code);
        setDsXetNghiemDetail([]);
      }
    } catch (error) {
      console.error(error);
      setDsXetNghiemDetail([]);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteDSChiDinhDV(selectedPhieu?.id);
      handleUpdate();
      setSelectedIndex(0);
    } catch (error) {
      console.error(error);
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    }
  };

  const updataData = async () => {
    try {
      let { data } = await getServiceListByType({
        visitId: visit?.id,
        type: ORDER_TYPE_ID.CHUYEN_KHOA,
      });
      if (CODE.SUCCESS === data?.code) {
        let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
          return {
            ...item,
            index,
            date: moment(item?.indicationTime).format("DD/MM/YYYY"),
          };
        });
        let currentIndex = orderId !== currentOrderId ? 0 : selectedIndex;
        setDsPhieu(dsPhieuConverted || []);
        handleSelectPhieu(dsPhieuConverted?.[currentIndex] || dsPhieuConverted?.[0]);
      } else {
        handleReset();
      }
    } catch (error) {
      console.error(error);
      handleReset();
    }
  };

  const handleClickWfButton = (data: any) => {
    setDynamicData({
      ...data,
      orderGroupId: selectedPhieu?.id,
      generalInfo,
      callbackFunc: () => {
        setSelectedIndex(0);
      },
      updateWorkflow: () => {
        setIsUpdateWorkflow(!isUpdateWorkflow);
      }
    });
  };

  useEffect(() => {
    setCurrentOrderId(orderId);
  }, [orderId]);

  useEffect(() => {
    if (orderId) {
      updataData();
    }
  }, [benhNhanInfo?.shouldUpdate, generalInfo?.updateTab, orderId]);

  useEffect(() => {
    handleGetStatusDesc();
  }, []);

  const handleViewResult = (data: any) => {
    if (!selectedPhieu?.isAllowModify || data?.isCancel) {
      return;
    };

    let isAllowEdit =
      data?.obs?.isAllowEdit ||
      (data?.terms ? data?.terms[0]?.obs?.isAllowEdit : null);
    let resultData = {
      ...data,
      ...data?.obs,
      ...data?.terms?.[0]?.obs,
    };
      
    if (isAllowEdit) {
      setShouldOpenResultModal(true);
      setSelectedRow(resultData);
    } else {
      toast.warning("Dịch vụ chưa được thanh toán!");
    }
  };

  useEffect(() => {
    selectedPhieu && setCurrentStatusWf(selectedPhieu?.currStatusCode);
  }, [selectedPhieu]);

  const handleSubmitForm = async (
    values: any,
  ) => {
    let valuesPTTT = {
      ...values,
      surgeryInitialDiagnosis: values?.surgeryInitialDiagnosis?.code || null,
      surgeryComorbidity: values?.surgeryComorbidity?.code || null,
      surgeryPreoperativeDiagnosis:
        values?.surgeryPreoperativeDiagnosis?.code || null,
      surgeryPostoperativeDiagnosis:
        values?.surgeryPostoperativeDiagnosis?.code || null,
    };
    let dataSubmit = values?.allowDisableRules ? values : {
      personId: patient?.personId,
      orderId: selectedRow?.orderId,
      values: valuesPTTT,
    };

    try {
      setIsLoading(true);
      let { data } = await createObsValue(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        toast.success("Lưu thực hiện thành công");
        setIsHasData(true);
      }
    } catch (error) {
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    } finally {
      setIsLoading(false);
    }
  };

  const columnsDSChuyenKhoa = [
		{
			title: 'Tên dịch vụ',
			field: 'name',
			className: 'spaces width-45',
			render: (rowData: any) => <CellFormatter rowData={rowData} value={rowData?.name} />,
		},
		{
			title: 'SL',
			field: 'quantity',
			className: 'spaces width-10 text-center',
			render: (rowData: any) => (
				<CellFormatter
					rowData={rowData}
					value={rowData?.isCancel ? 0 : rowData?.quantity ?? 1}
				/>
			),
		},
		{
			title: 'Kết quả',
			field: 'ketQua',
			className: 'spaces width-30',
			render: (rowData: any) => {
				const isFieldEnable = getWorkflowTrackerFieldConfig({
					workflowConfig: rowData?.additionalConfiguration,
					componentName: 'BangDsDichVuCK',
					field: 'obsValue',
				})?.write;

				return (
					<TableCustomCell
						className="s-2"
						data={
							<Formik
								initialValues={{}}
								onSubmit={() => {}}
								className="spaces w-100 fs-14"
							>
								{isFieldEnable ? (
									generateInput(rowData)
								) : (
                  <CellFormatter
										rowData={rowData}
										value={rowData?.obs?.value}
									/>
								)}
							</Formik>
						}
					/>
				);
			},
		},
		{
			title: 'Đối tượng',
			field: 'doiTuong',
			className: 'spaces width-15',
			render: (rowData: any) => (
				<CellFormatter rowData={rowData} value={rowData?.objectTypeName} />
			),
		},
  ];

  const handleSaveObs = async (rowData: any, value: any) => {
    try {
      if (value !== rowData?.obs?.value && (rowData?.obs?.value || value)) {
        setFieldLoading({ [rowData?.id]: true });
        
        const submitData = {
          personId: patient?.personId,
          orderId: rowData?.obs?.orderId,
          values: {
            conclusion: value || null,
            surgeryPrimarySurgeon1st: rowData?.obs?.attributeValue?.surgeryPrimarySurgeon1st 
              || null,
            surgeryInformationEntryDepartment: rowData?.obs?.attributeValue?.surgeryInformationEntryDepartment
              || null,
          },
        };

        let { data } = await createObsValue(submitData);
        data?.code === CODE_SUCCESS && toast.success("Lưu kết luận thành công!");
        
        const newData = dsXetNghiemDetail?.map((item: any) => {
          return {
            ...item,
            terms: item?.terms?.map((itemTerm: any) => {
              if (itemTerm?.id === rowData?.id) {
                return {
                  ...itemTerm,
                  obs: {
                    ...itemTerm.obs,
                    value: value,
                  },
                };
              }
              return itemTerm;
            }),
          };
        });
        setDsXetNghiemDetail(newData);
        // Không cần reload lại, data đã được update local
      }
    } catch (error) {
      toast.warning("Lỗi lưu kết luận, vui lòng nhập lại!");
    } finally {
      setFieldLoading({});
    }
  };

  const generateInput = (rowData: any) => {
    return (
      <div className="d-flex align-items-center spaces w-100 py-3">
        <TextField
          className="spaces w-100"
          name="value"
          defaultValue={rowData?.obs?.value || ""}
          disabled={isConclusion}
          onBlur={(e: FocusEvent<HTMLInputElement>) => {
            handleSaveObs(rowData, e.target.value);
          }}
        />
        {fieldLoading[rowData.id] && <span className="loading-spinner"></span>}
      </div>
    );
  };

  const handleClearContext = () => {
    setItemService(null);
    setContextMenu?.(null);
  };

  const handleGetStatusDesc = async () => {
    try {
      let { data } = await getStatusDesc(WfConstTracker.SURGERY_ORDER);
      if (data?.code === CODE.SUCCESS) {
        setStatusDesc(data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const MemoDynamicComponent = useMemo(() => (
    <DynamicComponentXN
      data={dynamicData}
      setData={setDynamicData}
      handleCancelService={handleCancelService}
      generalInfo={generalData}
      onConfirm={handleConfirmDelete}
      onUpdate={handleUpdate}
    />
  ), [dynamicData?.componentName]);

  return (
    <Row className="h-100">
      <div>
        <div className="pt-4 bg-white">
          <Row className="mx-0">
            <Col xs={4} className="d-flex align-items-center mb-3">
              <LabelRequired label="Mã phiếu" className="min-w-100px" />
              <span className="fw-light text-truncate">
                {selectedPhieu?.code || "..."}
              </span>{" "}
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
              <TimeEditor
                name="indicationTime"
                values={selectedPhieu}
                isEditingTime={indicationTimeManager.isEditingTime}
                editedTime={indicationTimeManager.editedTime}
                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                validationMessage={indicationTimeManager.validationMessage}
                onEdit={indicationTimeManager.handleEditTime}
                onCancel={indicationTimeManager.handleCancelEdit}
                onSave={indicationTimeManager.handleSaveTime}
                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                onCancelValidation={indicationTimeManager.handleCancelValidation}
                onTimeChange={indicationTimeManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={4}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Người chỉ định" className="min-w-100px" />
              <SelectEditor
                name="indicationPerson"
                values={{
                  indicationPerson: selectedPhieu?.indicationPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={4}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Nơi chỉ định" className="min-w-100px" />
              <SelectEditor
                name="requestDeptName"
                values={{
                  requestDeptName: selectedPhieu?.requestDeptName
                }}
                options={danhSachDanhMuc?.listPhongKham || []}
                inline={true}
                menuPlacement="top"
                isEditingSelect={requestDeptNameSelectManager.isEditingSelect}
                editedValue={requestDeptNameSelectManager.editedValue}
                showValidationConfirm={requestDeptNameSelectManager.showValidationConfirm}
                showConfirmWithReason={requestDeptNameSelectManager.showConfirmWithReason}
                validationMessage={requestDeptNameSelectManager.validationMessage}
                onEdit={requestDeptNameSelectManager.handleEditSelect}
                onCancel={requestDeptNameSelectManager.handleCancelEdit}
                onSave={requestDeptNameSelectManager.handleSaveSelect}
                onConfirmValidation={requestDeptNameSelectManager.handleConfirmValidation}
                onCancelValidation={requestDeptNameSelectManager.handleCancelValidation}
                onConfirmWithReason={requestDeptNameSelectManager.handleConfirmWithReason}
                onCancelWithReason={requestDeptNameSelectManager.handleCancelWithReason}
                onValueChange={requestDeptNameSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={8}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Chẩn đoán" className="min-w-100px" />
              <span className="fw-light text-truncate">
                {selectedPhieu?.provisionalDiagnosisName || "..."}
              </span>
            </Col>
          </Row>
        </div>
        <div className="bg-white spaces pt-2 mb-6">
          <DanhSachPhieu
            className="mb-2"
            handleSelectRowData={handleSelectPhieu}
            dsPhieu={dsPhieu as []}
            listColorPhieu={LIST_COLOR_TRANG_THAI_PHIEU}
            selectedIndex={selectedIndex}
          />
          <TableCollapseCustom
            columns={columnsDSChuyenKhoa}
            data={dsXetNghiemDetail || []}
            childrenField="subs"
            className={`overflow-auto spaces h-calc-vh-${generalInfo?.isKhamDoan ? "400" : "500"}`}
            handleDoubleClick={handleViewResult}
            handleContextMenu={handleContextMenu}
          />
        </div>
        <div className="d-flex justify-content-between align-items-center p-2 gap-3 bg-white">
          <div className="d-flex">
            {visit?.id 
              && patient?.id 
              && selectedPhieu?.id 
              && WORKFLOW_ORDER_GROUP_STATUS_CODE.HUY_GUI_PHIEU !== currentStatusWf 
              && (
              <>
                <ButtonInPhieu
                  className="spaces mx-3"
                  label="Phiếu chỉ định chung"
                  fetchExport={inPhieuChiDinhChung}
                  params={{
                    visitId: visit?.id,
                    patientId: patient?.id,
                    orderGroupId: selectedPhieu?.id,
                  }}
                />
                <ButtonInPhieu
                  className="spaces mx-3"
                  label="Phiếu chỉ định theo phòng"
                  fetchExport={inPhieuChiDinhChung}
                  params={{
                    visitId: visit?.id,
                    patientId: patient?.id,
                    orderGroupId: selectedPhieu?.id,
                    isSplit: true
                  }}
                />
                <ButtonInPhieu
                  className="spaces mx-3"
                  label="Phiếu chỉ định (F2)"
                  fetchExport={inPhieuChiDinhCLS}
                  params={{
                    visitId: visit?.id,
                    patientId: patient?.id,
                    orderGroupId: selectedPhieu?.id,
                    orderTypeId: ORDER_TYPE_ID.CHUYEN_KHOA,
                  }}
                  keyBtn={KEY.F2}
                />
                <ButtonInPhieu
                  className="spaces mx-3"
                  label="Phiếu trị liệu"
                  params={{}}
                  signatureParams={{
                    id: selectedPhieu?.id,
                    objectType: SIGNATURE_OBJECT_TYPE.ORDER,
                    module: SIGNATURE_MODULE.SURGERY,
                    type: SIGNATURE_TYPE.PHIEU_TH_CHUYEN_KHOA,
                  }}
                />
              </>
            )}
            {selectedPhieu?.isAllowModify && !isConclusion && (
              <WfButton
                tracker={WfConstTrackerClinical.ORDER_GROUP}
                objectId={selectedPhieu?.id}
                additionalFunc={actionChanged}
                handleClick={handleClickWfButton}
                forceRender={isUpdateWorkflow}
              />
            )}
          </div>
          <ShowStatus className="status-summary" statuses={statusDesc} />
        </div>

        {!rowSelected?.isCancel && contextMenu && (
          <WfContextMenu
            handleCloseMenu={() => {
              handleClearContext();
            }}
            target={contextMenu}
            tracker={WfConstTracker.SURGERY_ORDER}
            objectId={itemService?.termOrderId}
            additionalFunc={actionChanged}
            additionalProps={{
              ...itemService,
              personId: patient?.personId,
              orderId: itemService?.orderId
            }}
            componentName="TabChuyenKhoa"
            handleClick={(data) => {
              handleClickWfButton(data);
            }}
          />
        )}
      </div>
      {dynamicData && MemoDynamicComponent}
      {shouldOpenResultModal && (
        <ModalThucHienChuyenKhoa
          handleClose={() => {
            // Không cần reload, data đã được update trong handleSubmitForm
            setShouldOpenResultModal(false);
            setIsHasData(false);
          }}
          handleTraKetQua={() => {}}
          infoBenhNhan={benhNhanInfo?.thongTinKhamBenh || generalInfo}
          selectedRow={selectedRow}
          handleSubmitForm={handleSubmitForm}
          listICD10={categories?.listICD10}
          isHasData={isHasData}
          setIsHasData={setIsHasData}
          isViewModal={isConclusion}
        />
      )}
    </Row>
  );
};

export default TabChuyenKhoa;
